const NAME = 'SENDBIRD';

export const getMessages = (id) => (store) => {
  const data = store[NAME].message.list.data || {};
  return id ? data[id] : [];
};
